import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading font-bold text-lg">
                研
              </span>
              <span className="font-heading font-semibold text-foreground-950 text-base">
                援助交配现象研究中心
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              致力于以客观、理性的学术视角，深度研究援助交配现象的社会成因、心理机制与多维影响。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4 text-sm">研究分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4 text-sm">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">关于我们</Link></li>
              <li><Link to="/about#contact" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200">联系我们</Link></li>
              <li><a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200" rel="nofollow">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4 text-sm">联系方式</h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-foreground-400"></i>
                <span>research@yuanzhu-jiaopei.org</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-foreground-400"></i>
                <span>北京市海淀区中关村学术研究中心</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 援助交配现象研究中心. 本站内容仅供学术研究参考.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-foreground-600 transition-colors duration-200" aria-label="微信公众号" rel="nofollow">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-foreground-600 transition-colors duration-200" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}